import React, { useContext } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { ThemeContext } from "../context/ThemeContext";
import muiTheme from "./muiTheme";
import muiThemeClaro from "./muiThemeClaro";

// Aplica o tema MUI conforme o botão de tema do sistema (claro/escuro).
// As telas continuam passando theme={muiTheme}; aqui o tema é escolhido
// pelo modo atual: escuro usa exatamente o muiTheme original.
export default function TemaMuiProvider({ children }) {
  const contexto = useContext(ThemeContext);
  const temaEscuro = contexto ? contexto.temaEscuro : true;
  return <ThemeProvider theme={temaEscuro ? muiTheme : muiThemeClaro}>{children}</ThemeProvider>;
}
